var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortugal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 37,
    viewBox: "0 0 51 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_88179)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.475586,
    y: 0.588867,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.475586 0.588867H17.2756V36.5889H0.475586V0.588867Z",
    fill: "#249F58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2771 24.5904C21.2536 24.5904 24.4771 21.3669 24.4771 17.3904C24.4771 13.414 21.2536 10.1904 17.2771 10.1904C13.3007 10.1904 10.0771 13.414 10.0771 17.3904C10.0771 21.3669 13.3007 24.5904 17.2771 24.5904Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0756 19.7889V12.5889H12.4756V19.7889C12.4756 21.1137 14.6236 22.1889 17.2756 22.1889C19.9276 22.1889 22.0756 21.1137 22.0756 19.7889Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.874 14.9873H19.674V19.7873H14.874V14.9873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.874 14.9873H17.274V17.3873H14.874V14.9873ZM17.274 17.3873H19.674V19.7873H17.274V17.3873Z",
    fill: "#1A47B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_88179"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.475586,
    y: 0.588867,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugal);
export default __webpack_public_path__ + "static/media/Portugal.4f48b099d85581d135012f6aedfdab89.svg";
export { ForwardRef as ReactComponent };